<template>
  <div ref="slider"></div>
</template>

<script>
export default {
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    value: {
      default: 0
    },
    options: {
      default: {
        min: 0,
        max: 100,
        step: 10,
      }
    }
  },
  data() {
    return {
      slider: null,
    }
  },
  watch: {
    value(nVal, oVal) {
      if(nVal == oVal) return

      this.set()
    },
    options: {
      handler: function (nVal) {
        debugger
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.kill()
  },
  methods: {
    kill() {
      if (!this.slider) return

      // this.$refs.slider.off('update')
      this.slider.off('update')
      // this.$refs.slider.destroy()
      this.slider.destroy()
      this.slider = null
    },
    init() {
      this.kill()

      this.slider = noUiSlider.create(this.$refs.slider, {
        start: this.value,
        connect: true,
        step: this.options.step,
        range: {
          "min": this.options.min,
          "max": this.options.max,
        }
      });

      const self = this
      this.$refs.slider.noUiSlider.on("update", function (values, handle) {
        // console.log(values, handle)
        self.$emit('change', values[handle])
      });
    },
    set(){
      if(!this.slider) return

      this.slider.set(this.value)
    },
  }
}
</script>